import { machSetAlertVisibility } from "./alerts";
import { machSetCurrentOpeningHours } from "./opening-hours";

let arrLeonardGTMTrackingFormPath = [];
let menuWidth = 1024;

jQuery(document).ready(function () {
    machRedirectContactForm();
    initLeonardGTMTracking();

    jQuery(document).on("click", ".mobile-menu-btn", machToggleOverlayMenu);

    jQuery(document).on("click", ".mobile-main-menu .menu > li.menu-item-has-children > a", machHeaderOpenSubMenu);

    jQuery(document).on("touchstart", ".main-menu .menu > li.menu-item-has-children > a", machTouchStart);

    jQuery(".toggle-detailed-hours").on("click", machToggleDetailedHours);

    jQuery(".page-down-btn").on("click", machScrollBelowPageHeader);
    jQuery(".scroll-top-btn").on("click", machScrollToTop);
    jQuery(".accordion-box .toggle-link").on("click", machToggleAccordionBox);

    jQuery(".vertical-toggles.js-toggle .toggle-link").on("click", machVerticalTogglesLinkClick);
    jQuery(".vertical-toggles select[name='toggle_select']").on("change", machVerticalTogglesSelectChange);

    setTimeout(function () {
        machAdjustStoreMapLink();
    }, 3000);

    machAdjustEmailObfuscation();

    machHandleScroll();
    jQuery(window).scroll(function () {
        debounce(machHandleScroll, 25);
    });

    machRetrieveRealTimeData();
    machSetDynamicHeaderHeight();
    machSetPageTitleHeaderStickyStatus();
    jQuery(window).resize(function () {
        machSetDynamicHeaderHeight();
        machSetPageTitleHeaderStickyStatus();
    });

    machInitFadeUpInAnimation();

    machFixSvgInlineStylesConflicts();
});

export function machSetDynamicHeaderHeight() {
    jQuery(":root").css("--header-height", jQuery(".main-header-fixed").innerHeight() + "px");
    jQuery(":root").css("--internal-header-height", jQuery(".main-header-content").innerHeight() + "px");
}

function machRetrieveRealTimeData(e) {
    const cachedOpeningHours = machGetCookie("mach_mall_opening_hours");
    let retrieveOpeningHours = true;

    if (cachedOpeningHours) {
        try {
            const parsedOpeningHours = JSON.parse(cachedOpeningHours);
            retrieveOpeningHours = false;
            machSetCurrentOpeningHours(parsedOpeningHours);
        } catch (error) {
            console.error("Error when reading cache opening hours:", error);
        }
    }

    // Faire l'appel AJAX quand même pour actualiser les données
    jQuery.ajax({
        url: backendInfo.ajaxurl,
        type: "GET",
        data: {
            action: "mach_retrieve_real_time_data",
            lang: backendInfo.locale,
            retrieve_opening_hours: retrieveOpeningHours ? "1" : "0",
        },
        success: function (result) {
            if (result.alert) {
                machSetAlertVisibility(result.alert);
            }
            if (result.opening_hours) {
                machSetCurrentOpeningHours(result.opening_hours);
                // Store opening hours in a cookie that expires in 1 hour
                machSetCookie("mach_mall_opening_hours", JSON.stringify(result.opening_hours), 1);
            }
        },
    });
}

/**
 * If the page header is taller than the window, it cannot be sticky
 */
function machSetPageTitleHeaderStickyStatus() {
    let $pageHeader = jQuery(".page-header");
    let windowHeight = jQuery(window).innerHeight();
    if ($pageHeader.length) {
        if ($pageHeader.innerHeight() > windowHeight + 60) {
            $pageHeader.removeClass("sticky");
        }
    }
}

function machTouchStart(e) {
    if (window.innerWidth > menuWidth) {
        jQuery(".main-menu").addClass("prevent-tablet");
    }
}

function machToggleOverlayMenu(e) {
    jQuery(this).toggleClass("menu-open");
    jQuery("html").toggleClass("menu-open");
    jQuery(".mobile-menu").toggleClass("hidden");

    e.preventDefault();
}

/**
 * Open the mobile sub menu items on the parent link click
 */
function machHeaderOpenSubMenu(e) {
    jQuery(this).toggleClass("opened");
    jQuery(this).parent().find(".sub-menu").first().toggleClass("opened");

    e.preventDefault();
}

// Handle scroll events (ie: fexed menu background)
function machHandleScroll() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > 50) {
        jQuery(".main-header-fixed").addClass("scrolled");
        machSetDynamicHeaderHeight();
    }
    if (scrollTop == 0) {
        jQuery(".main-header-fixed").removeClass("scrolled");
        machSetDynamicHeaderHeight();
    }

    if (scrollTop > jQuery(window).height()) {
        jQuery(".scroll-top-btn").addClass("visible");
    } else {
        jQuery(".scroll-top-btn").removeClass("visible");
    }
}

function machToggleDetailedHours(e) {
    jQuery(this).parents(".hours-header-preview").find(".detailed-hours").toggleClass("hidden");
    jQuery(this).find("svg").toggleClass("rotate-180");
    e.preventDefault();
}

function machRedirectContactForm() {
    document.addEventListener(
        "wpcf7mailsent",
        function (event) {
            let redirectUrl = jQuery("input[name=redirect_url]").val();
            if (redirectUrl != undefined) {
                location = redirectUrl;
            }
        },
        false
    );
}

function machInitFadeUpInAnimation() {
    // Get all the elements to show on scroll
    var $targets = jQuery(".animate-fade-up-appear");

    // Set up a new observer
    var observer = new IntersectionObserver((entries) => {
        entries.forEach(function (entry) {
            // Is the element in the viewport?
            if (entry.isIntersecting) {
                // Add the fadeIn class
                jQuery(entry.target).addClass("animate-fade-up-in");
            }
        });
    });

    // Loop through each of the targets
    $targets.each(function () {
        var $target = jQuery(this);

        // Hide the element
        $target.addClass("opacity-0");
        $target.addClass("translate-y-16");

        // Add the element to the watcher
        observer.observe(this);
    });
}

function machScrollBelowPageHeader(e) {
    let $pageHeader = jQuery(".page-header");
    if ($pageHeader.length > 0) {
        jQuery("html, body").animate(
            {
                scrollTop: $pageHeader.offset().top + $pageHeader.innerHeight() - jQuery(".main-header-fixed").innerHeight(),
            },
            300
        );
    }
    e.preventDefault();
}

function machScrollToTop(e) {
    e.preventDefault();
    jQuery("html, body").animate(
        {
            scrollTop: 0,
        },
        350
    );
}

function initLeonardGTMTracking() {
    // Track CTA pointing to a «Leads Form»
    // -------
    let arrLeonardGTMTrackingCTA = [];

    for (let i = 0; i < arrLeonardGTMTrackingFormPath.length; i++) {
        arrLeonardGTMTrackingCTA.push(
            "a.p-btn[href*='" + arrLeonardGTMTrackingFormPath[i] + "'], a.p-button[href*='" + arrLeonardGTMTrackingFormPath[i] + "']"
        );
    }

    // Custom CSS rules here
    // arrLeonardGTMTrackingCTA.push(".custom-rule-for-CTA-pointing-to-leads-form a");

    jQuery(arrLeonardGTMTrackingCTA.join(", ")).addClass("gtm-form-view");

    // Track «Leads form» submit button click
    // -------
    if (arrLeonardGTMTrackingFormPath.indexOf(window.location.pathname) != -1) {
        jQuery("form button, form input[type=submit]").addClass("gtm-form-submited");
    }
}

export function debounce(method, delay) {
    clearTimeout(method._tId);
    method._tId = setTimeout(function () {
        method();
    }, delay);
}

export function machSetCookie(name, value, hours) {
    var date = new Date();
    date.setTime(date.getTime() + hours * 60 * 60 * 1000);
    var expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

export function machGetCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

export function machToggleLoadingScreen() {
    jQuery(".global-loading-screen").toggleClass("hidden");
}

export function machAdjustEmailObfuscation() {
    jQuery(".mailto-obfuscate").each(function () {
        let encrypted_email = jQuery(this).data("value");
        if (encrypted_email) {
            jQuery(this).attr("href", "mailto:" + atob(encrypted_email));
            if (jQuery(this).hasClass("replace-text")) {
                jQuery(this).text(atob(encrypted_email));
            }
        }
    });
}

function machToggleAccordionBox(e) {
    e.preventDefault();
    jQuery(this).parents(".accordion-box").toggleClass("opened");
    jQuery(this).parents(".accordion-box").find(".content").slideToggle(300);
    jQuery(this).parents(".accordion-box").find(".toggle-element").toggleClass("opened");
}

function machAdjustStoreMapLink() {
    jQuery(".store-map-link").each(function () {
        let storeId = jQuery(this).data("store-id");
        let mapLevelId = jQuery(this).data("map-level-id");
        jQuery(this).attr("href", jQuery(this).attr("href") + "?storeId=" + storeId + "&mapLevelId=" + mapLevelId);
    });
}

function machVerticalTogglesLinkClick(e) {
    e.preventDefault();
    let $toggleLink = jQuery(this);
    let toggleContentId = $toggleLink.data("toggle-id");
    let $togglesWrapper = jQuery(this).parents(".vertical-toggles");
    let $togglesSelect = $togglesWrapper.find("select[name='toggle_select']");

    if (!toggleContentId) {
        $togglesSelect.val("");
    } else {
        $togglesSelect.val($togglesSelect.find("option[data-toggle-id='" + toggleContentId + "']").val());
    }

    machVerticalToggleChangeActiveContent(toggleContentId, $togglesWrapper);
}

function machVerticalToggleChangeActiveContent(toggleContentId, $togglesWrapper) {
    if (toggleContentId == undefined || toggleContentId == "") {
        $togglesWrapper.find(".toggle-content").show();
        $togglesWrapper.find(".toggle-link").removeClass("selected");
        $togglesWrapper.find(".toggle-link").first().addClass("selected");
        return;
    }

    let $toggleContent = $togglesWrapper.find(".toggle-content[data-toggle-id='" + toggleContentId + "']");
    let $toggleLink = $togglesWrapper.find(".toggle-link[data-toggle-id='" + toggleContentId + "']");

    if ($toggleContent.length) {
        $togglesWrapper.find(".toggle-content").hide();
        $togglesWrapper.find(".toggle-link").removeClass("selected");
        $toggleContent.show();
        $toggleLink.addClass("selected");
        return;
    }
}

function machVerticalTogglesSelectChange(e) {
    let $togglesWrapper = jQuery(this).parents(".vertical-toggles");
    let $selectedOption = jQuery(this).find("option:selected");

    if ($togglesWrapper.hasClass("js-toggle")) {
        machVerticalToggleChangeActiveContent($selectedOption.data("toggle-id"), $togglesWrapper);
    } else {
        // Navigate to a new page
        let newUrl = $selectedOption.val();
        if (newUrl) {
            window.location.href = newUrl;
        }
    }
}

export function machGetUrlParameterByName(name) {
    var url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

// When multiple SVGs use the same class name (cls-1, st1), it can cause styling conflicts.
// This code gives each SVG's cls-1 elements a unique class name to prevent these conflicts
export function machFixSvgInlineStylesConflicts() {
    jQuery("svg").each(function (index) {
        const $svg = jQuery(this);
        // Find all style tags within this SVG
        const styleTags = $svg.find("style");

        // Get all classes from style tags that start with cls- or st-
        const clsClasses = new Set();
        styleTags.each(function () {
            const matches = this.textContent.match(/\.(cls-|st)[^\s,.{]+/g);
            if (matches) {
                matches.forEach((match) => clsClasses.add(match.substring(1))); // Remove the leading dot
            }
        });

        // Process each cls- class
        clsClasses.forEach((clsClass) => {
            const uniqueClass = `${clsClass}-svg-${index}`;

            // Update style content
            styleTags.each(function () {
                this.textContent = this.textContent.replace(new RegExp(`\\.${clsClass}\\b`, "g"), `.${uniqueClass}`);
            });

            // Update elements with the cls- class
            $svg.find(`.${clsClass}`).removeClass(clsClass).addClass(uniqueClass);
        });
    });
}
